const OUTGOING_STATUS_ROUTE = '/outgoing-status'

export { OUTGOING_STATUS_ROUTE }
